import { MuxSpecificationItemResponse } from "../../../../common/api/orders-api/mux-specification/responses/MuxSpecificationItemResponse";
import { LanguageSpecificationType } from "../../../../common/types/LanguageSpecificationType";
import { MuxerType } from "../../../../common/types/MuxerType";

export interface OrderMuxSpecificationItem {
    id: string;
    name: string;
    isSequentialForSoundtracks: boolean;
    isSequentialForSubtitles: boolean;
}

export const mapToOrderMuxSpecificationItem = (response: MuxSpecificationItemResponse): OrderMuxSpecificationItem => ({
    id: response.id,
    name: response.name,
    isSequentialForSoundtracks:
        response.muxerType === MuxerType.GPAC ||
        (response.muxerType === MuxerType.Manzanita &&
            response.languageSpecification.type === LanguageSpecificationType.Sequential),
    isSequentialForSubtitles: response.muxerType === MuxerType.GPAC
});
